(()=>{const routes={'/pages/natural-diamonds':false,'/pages/fancy-natural-diamonds':false,'/pages/lab-grown-diamonds':true,'/pages/fancy-lab-grown-diamonds':true};if(!Object.prototype.hasOwnProperty.call(routes,location.pathname))return;let initializing=true;const stop=()=>{initializing=false};for(const name of ['pointerdown','keydown','touchstart'])window.addEventListener(name,stop,{once:true,capture:true,passive:true});window.setTimeout(stop,20000);const replace=history.replaceState;const push=history.pushState;const u=new URL(location.href);if(!u.searchParams.has('activeTab')&&!u.searchParams.has('queryLabGrown')){u.searchParams.set('activeTab',routes[location.pathname]?'Lab Grown':'Natural');u.searchParams.set('queryLabGrown',String(routes[location.pathname]));replace.call(history,history.state,'',u.href);}history.pushState=function(state,title,url){let duplicate=false;try{duplicate=initializing&&url!=null&&new URL(String(url),location.href).href===location.href;}catch(_){}return (duplicate?replace:push).apply(this,arguments);};})();
(()=>{
  const shell=document.querySelector('[data-it-market-shell]');
  if(!shell)return;

  const hero=shell.querySelector('[data-it-market-hero]');
  const detail=shell.querySelector('[data-it-market-detail]');
  const pageHandle=shell.dataset.pageHandle||'';
  const originMap={
    'natural-diamonds':'natural',
    'lab-grown-diamonds':'lab-grown',
    'fancy-natural-diamonds':'fancy-natural',
    'fancy-lab-grown-diamonds':'fancy-lab-grown',
    'gemstones':'gemstone',
    'ring-configurator':'ring-configurator'
  };
  const marketplaceContext=originMap[pageHandle]||pageHandle||'marketplace';
  const params=()=>new URLSearchParams(location.search);
  // IT_DIAMOND_RETURN_V3: only the observed standalone lab-grown error action.
  const inventoryReturn=()=>{
    const p=params();
    if(pageHandle!=='lab-grown-diamonds'||p.has('stage')||!(p.get('id')||p.get('viewDetailsId')))return null;
    const url=new URL(location.href);
    ['id','viewDetailsId','stoneType'].forEach(key=>url.searchParams.delete(key));
    url.hash='';
    return url;
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('button');
    const app=shell.closest('.shopify-section')?.nextElementSibling;
    if(!button||!app?.contains(button)||button.textContent.trim()!=='See More Diamonds')return;
    if(!button.parentElement?.textContent.includes('Oops! Product Not Found'))return;
    const url=inventoryReturn();
    if(!url)return;
    event.preventDefault();event.stopImmediatePropagation();
    location.assign(url.href);
  },true);
  const stoneId=()=>params().get('viewDetailsId')||'';
  const isDetail=()=>!!stoneId();
  const base=()=>({
    marketplace_context:marketplaceContext,
    page_handle:pageHandle,
    marketplace_state:isDetail()?'detail':'inventory',
    stone_id:stoneId(),
    page_path:location.pathname+location.search
  });
  const push=(event,extra={})=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event,...base(),...extra});
  };
  const views=new Set();
  const emitView=()=>{
    const signature=[pageHandle,isDetail()?'detail':'inventory',stoneId(),location.pathname+location.search].join('|');
    if(views.has(signature))return;
    views.add(signature);
    push(isDetail()?'nivoda_marketplace_detail_view':'nivoda_marketplace_view');
  };
  const markNivodaDesign=()=>{
    /* IT_NIVODA_DESIGN_BRIDGE_V2 — visual classes only; native Nivoda remains source of truth. */
    const host=shell.closest('.shopify-section');
    const app=host&&host.nextElementSibling;
    if(!app)return;
    app.dataset.itNivodaApp='true';
    app.querySelectorAll('button,a,[role="button"]').forEach(el=>{
      const label=String(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(label==='add to cart'||label==='add to basket')el.classList.add('it-nivoda-buy');
      if(label.includes('view detail')||label.includes('view diamond')||label.includes('select diamond')||label==='select')el.classList.add('it-nivoda-secondary');
    });
    app.querySelectorAll('img').forEach(img=>img.classList.add('it-nivoda-image'));
  };
  const sync=()=>{
    const d=isDetail();
    // IT_DIAMOND_RETURN_V1: a real navigation escapes a failed app detail state.
    const browse=shell.querySelector('a[href="#it-market-inventory"],a[data-it-market-return]');
    if(pageHandle==='lab-grown-diamonds'&&browse){
      if(params().get('id')){
        const inventory=new URL(location.href);
        ['id','viewDetailsId','stoneType'].forEach(key=>inventory.searchParams.delete(key));
        inventory.hash='';
        browse.href=inventory.href;
        browse.dataset.itMarketReturn='true';
      }else{
        browse.setAttribute('href','#it-market-inventory');
        delete browse.dataset.itMarketReturn;
      }
    }
    if(hero)hero.hidden=d;
    if(detail)detail.hidden=!d;
    document.querySelectorAll('[data-it-market-whatsapp]').forEach(a=>{
      a.href='https://wa.me/447538174795?text='+encodeURIComponent('Hello Imperial Time, I’d like help with this page: '+location.href);
    });
    markNivodaDesign();
    emitView();
  };

  shell.addEventListener('click',event=>{
    const link=event.target.closest?.('a');
    if(!link||!shell.contains(link)||!link.matches('.it-market-actions a,[data-it-market-detail] a'))return;
    const href=link.getAttribute('href')||'';
    const action=link.matches('[data-it-market-whatsapp]')?'whatsapp':href.startsWith('#it-market-inventory')?'inventory':href.includes('/pages/design-your-ring')?'ring-builder':'navigation';
    push('nivoda_marketplace_cta_click',{
      cta_action:action,
      cta_text:String(link.textContent||'').trim().slice(0,180),
      link_url:href
    });
  },true);

  let last=location.href;
  const changed=()=>{
    if(location.href!==last){
      last=location.href;
      sync();
    }
  };
  ['pushState','replaceState'].forEach(k=>{
    const original=history[k];
    if(typeof original==='function')history[k]=function(){
      const r=original.apply(this,arguments);
      queueMicrotask(changed);
      return r;
    };
  });
  window.addEventListener('popstate',()=>{
    last=location.href;
    sync();
  });
  new MutationObserver(()=>{changed();markNivodaDesign();}).observe(document.body,{subtree:true,childList:true});
  sync();
})();
